export default __webpack_public_path__ + "static/media/1.edd9edba.png";